import { Container } from 'design-react-kit'; 
import { SchedaPersonaSimpleView } from 'uniba-volto-persone/components';

const SchedaPersonaWrapperView = (props) => { 
    return (
        <Container className={`scheda-persona-view pb-2 pt-2 ${props?.content?.review_state}`}>
            <SchedaPersonaSimpleView props={props} showViewLink={false} />
        </Container>
    );
};

export default SchedaPersonaWrapperView;


